export const DYNAMIC_OPTION_TYPES = ['parameters', 'treatments']

export function getValueTypeKey (sfconfig) {
  let val = sfconfig.valueType // ['waveform', 'string']
  if (['integer', 'decimal1', 'decimal2', 'real'].includes(sfconfig.valueType)) {
    val = 'number'
  } else if (sfconfig.valueType === 'enum') {
    val = 'string'
  }

  let pluralSuffix = '' //['field', 'formattedText', 'slider, 'toggle', 'select']
  if (['checkboxes','fieldRange', 'sliderRange'].includes(sfconfig.view.inputType)) {
    pluralSuffix = 's'
  }

  return val + 'Value' + pluralSuffix
}

export function validateSegmentList(segList) {
  if(!segList || segList.length===0){
    return [...Array(30).keys()].map((i)=>i+1) //Array del 1 al 30
  } else {
    return segList
  }
}

export function getFieldValue (field) {
  // if(!field.value) return field
  // if(Array.isArray(field.value)){
  //   return field.value.map((sv)=>getFieldValue(sv))
  // } else
   if(typeof field.value === 'object'){
    let keys = Object.keys(field.value)
    let val = field.value[keys[0]]
    if(val && typeof val === 'object') val = val.name
    return val
  } else if(field.fields){
    return field.fields.map((sf)=>`${sf.name}: ${getFieldValue(sf)}`)
  } else {
    return field.value
  }
  // return field.value && (field.value.numberValue || field.value.stringValue)
}

export function getOption(source,optionType, directKey = false){
  if (optionType==='treatments' || directKey) return source[optionType]
  else return source.cohortGeneration.population[optionType]
}

export function setOption(source,optionType,value, directKey = false){
  if (optionType==='treatments' || directKey) source[optionType] = value
  else source.cohortGeneration.population[optionType] = value
}

// export function mergeConfigData (_configItem, _valueItem) {
//   let configItem = _configItem && JSON.parse(JSON.stringify(_configItem))
//   let valueItem = _valueItem && JSON.parse(JSON.stringify(_valueItem))
//   if (valueItem) {
//     configItem.fieldList.forEach(fieldConfigItem => {
//       let fieldValueItem = valueItem.fieldList.find(d => d.id == fieldConfigItem.id)

//       if(fieldConfigItem.subFieldList){
//         if (fieldConfigItem.segmentConfig) { // cas 4
//           // fieldConfigItem.subFieldList.forEach((sf)=>{
//           //   sf.segmentList = []
//           //   fieldValueItem.segmentList.forEach((segment) => {
//           //     let sfSegmentValue = segment.subFieldList.find(d => d.id == sf.id)
//           //     sf.segmentList.push({segmentId: segment.segmentId, value: sfSegmentValue.value})
//           //   })
//           // })
//           // cas 4 v.1
//           fieldConfigItem.segmentList = fieldValueItem.segmentList
//           fieldConfigItem.segmentList.forEach((segment)=> {
//             segment.subFieldList.forEach((sf) => {
//               let elem = fieldConfigItem.subFieldList.find( (sfConfig) => sfConfig.id === sf.id)
//               sf.parameterConfig = elem.parameterConfig
//               sf.name = elem.name
//               sf.order = elem.order
//               sf.description = elem.description
//             })
//           })
//         } else { // cas 2
//           fieldConfigItem.subFieldList.forEach((sf)=>{
//             let subFieldValueItem = fieldValueItem.subFieldList.find(d => d.id == sf.id)
//             sf.value = subFieldValueItem.value
//           })
//         }
//       } else {
//         if (fieldConfigItem.segmentConfig) { // cas 3
//           fieldConfigItem.segmentList = fieldValueItem.segmentList
//           fieldConfigItem.segmentList.forEach((segment)=> {
//             segment.parameterConfig = fieldConfigItem.parameterConfig
//             segment.name = fieldConfigItem.name
//             segment.order = fieldConfigItem.order
//             segment.description = fieldConfigItem.description
//           })
//         } else { // cas 1
//           fieldConfigItem.value = fieldValueItem.value
//         }
//       }
//     })
//   }
//   return configItem
// }
import store from '@/store'
export function createEmptyTrial(name,parentProject){
  // create a new trial template
  let optionsLists = store.state.trialOptions.data
  let newTrial = {cohortGeneration:{population:DYNAMIC_OPTION_TYPES.reduce((ob,key)=> (ob[key]=[],ob),{})}}

  // populations.parameters are added by default
  newTrial.cohortGeneration.population.parameters = optionsLists.parameters

  // parece que hay que inyectarle el projectId
  
  newTrial.projectId = parentProject.id
  newTrial.name = name
  return new Promise((res,rej)=>{
    res(newTrial)
  })
}

export function formatRanges(array) {
  var ranges = [], rstart, rend;
  for (var i = 0; i < array.length; i++) {
    rstart = array[i];
    rend = rstart;
    while (array[i + 1] - array[i] == 1) {
      rend = array[i + 1]; // increment the index if the numbers sequential
      i++;
    }
    ranges.push(rstart == rend ? rstart+'' : rstart + '-' + rend);
  }
  return ranges;
}

export function getSegmentsWithValuesForProject(project, paramConfig) {
  let segments = []
  project.trials.forEach(trial => {
    let optArray = getOption(trial, paramConfig.optionType)
    let opt = optArray && optArray.find((d)=>d.id === paramConfig.option.id)
    if(opt){
      let res = opt.fields.filter(f => f.view.inputType==="bullseye").map((d)=>d.value).flat()
      let segs = res.map((sp)=>{
        return sp.value.map((multiValue)=>{
          let arr = Array.isArray(multiValue.value[0].value)?multiValue.value[0].value:[multiValue.value[0].value]
          return arr
        }).flat()
      })
      segments = segments.concat(segs.flat())
    }
  })
  return [...new Set(segments)];
}

import Api from '@/api'
export function createEmptyProject(name, scenario){
  // create a new trial template
  // let optionsLists = store.state.trialOptions.data
  return Api.getProjectFields().then(fields=>{
    let newProject =       {
      relatedProjectId: 0,
      creationTimestamp: new Date().toISOString(),
      name: name,
      scenario: scenario,
      description: '',
      status: 'draft',
      fields: fields,
      trials: []
    }
    return newProject
  })
}
